<template>
  <div class="card h-100">
    <div class="card-body">
      <p class="mb-2">
        <small class="font-weight-bold">FDM Performance</small>
      </p>
      <highcharts :options="chartOptions" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    categories: {
      type: Array,
      required: true
    },
    series: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    chartOptions: {
      chart: {
        type: 'spline',
        height: 310
      },
      title: false,
      credits: false,
      xAxis: {
        categories: []
      },
      yAxis: {
        title: false
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom'
      },
      tooltip: {
        shared: true
      },
      series: []
    }
  }),

  watch: {
    categories: {
      immediate: true,
      handler (val) {
        this.chartOptions.xAxis.categories = val
      }
    },
    series: {
      deep: true,
      immediate: true,
      handler (val) {
        this.chartOptions.series = val
      }
    }
  }
}
</script>
